module.exports = __webpack_public_path__ + "media/images/icon__breadcrumbs-arrow-left--rb-raven-gray@2x-e9a20d83623e0d89165b7be3eff78fec.png";